import React, { useEffect, useState } from 'react'
import { getMappingAgencyList,loginAgency } from '@src/store/slices/insurance';
import Modal from '../../common/Modal';
import secureStorage from '@src/config/encrypt';
import { useNavigate } from 'react-router-dom';
import { LOGIN_TYPE } from '@src/config/constant';

function MappingAgencyListModal() {
  const [agencyList, setAgencyList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = secureStorage.getItem("authAgentUserInfo");
        let userInfo = result.user_data;
        let params = {id:userInfo.id}
        const response: any = await getMappingAgencyList(params);
        setAgencyList(response || []);
      } catch (error) {
        console.error("error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (show) { 
      fetchData();
    }
  }, [show]);

    const LoginAgency = async (agency: any) => {
        let result = secureStorage.getItem("authAgentUserInfo");
        let userInfo = result.user_data;
        
        let newObj:any = {}
        newObj.credit_terms = userInfo.credit_terms
        newObj.agency_id = agency.value
        newObj.api_source = userInfo.api_source
        newObj.login_type = LOGIN_TYPE[1]
        
        const response: any = await loginAgency(newObj);
        if (response?.token && response?.user_data) {
            const newUserInfo = {
                user_data: response.user_data,
                token: response.token
            };

            secureStorage.setItem('authAgentUserInfo', newUserInfo);
            // for reset name and id
            window.dispatchEvent(new Event("auth-info-updated"));
            setShow(false)
            navigate('/dashboard');
        }
    };


  return (
    <div className="model-outer sales-agency-list-popup">
      <Modal show={show} handleClose={handleClose} hideCloseIcon>
        <div className="modal-header">
          <h2>Select Agency</h2>
        </div>

        <div className="modal-body">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
             
              <ul>
                  {agencyList?.length === 0 ? (
                    
                      <li className="do-data-found">
                        No agencies found
                      </li>
                    
                  ) : (
                    agencyList?.map((agency: any, index: number) => (
                      
                        <li onClick={() => LoginAgency(agency)} >{agency.label} ({agency.value})</li>
                             
                    ))
                  )}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default MappingAgencyListModal;
